import $ from '../tools/Dom';
import { loadFlickity } from '../lib/async-bundles';

export default (el, data) => {
    let flkty;
    let Flickity;
    let hasSlider = false;

    const startFlickity = () => {
        hasSlider = true;
        flkty = new Flickity(el, {
            cellSelector: '[data-slide]',
            wrapAround: true,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: false,
            autoPlay: 3500,
            cellAlign: 'left',
            setGallerySize: true,
            percentPosition: true,
            accessibility: false
        });
    };

    const init = () => {
        loadFlickity(flickity => {
            Flickity = flickity;
            if (!hasSlider) {
                startFlickity();
            }
        });
    };

    const destroy = () => {};

    return {
        init,
        destroy
    };
};
